import { Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ToastModule } from '../shared-angular/modules/toast/toast.module';
import { UIView } from '@uirouter/angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [ToastModule, UIView]
})
export class AppComponent {
  private auth = inject(AuthService);

  title = 'VelocityCRM';
}
